import dotPropImmutable from 'dot-prop-immutable';
import moment from 'moment';
import { DEFAULT_DATE_FORMAT, MemberType } from 'api/models';
import { insert } from '../utils';
import { removeTaskFromDependencies } from './task';
function shiftStartDay(_subTasks, shiftBy, state) {
    return _subTasks === null || _subTasks === void 0 ? void 0 : _subTasks.reduce((intermediateState, sid)=>{
        const children = dotPropImmutable.get(intermediateState, `data.${state.activeId}.tasks.${sid}`);
        const updatedState = dotPropImmutable.set(intermediateState, `data.${state.activeId}.tasks.${sid}.startDay`, children.startDay + shiftBy);
        if (children.subTasks.length > 0) {
            return shiftStartDay(children.subTasks, shiftBy, updatedState);
        }
        return updatedState;
    }, state);
}
function deleteTasks(tasks, state) {
    return tasks ? tasks.reduce((intermediateState, taskId)=>{
        const children = dotPropImmutable.get(intermediateState, `data.${state.activeId}.tasks.${taskId}`);
        let updatedState = intermediateState;
        if (children.subTasks.length > 0) {
            updatedState = deleteTasks(children.subTasks, updatedState);
        }
        updatedState = {
            ...updatedState,
            ...dotPropImmutable.delete(updatedState, `data.${state.activeId}.tasks.${taskId}`)
        };
        return removeTaskFromDependencies(taskId, updatedState);
    }, state) : state;
}
export const projectPhaseSlice = {
    createProjectTemplateProjectPhase: (state, { payload: { projectPhase, insertAt } })=>{
        const newProjectPhase = {
            ...projectPhase,
            tasks: [],
            startDay: 1,
            duration: 1,
            isNewEntity: true
        };
        const projectPhasePath = `data.${state.activeId}.projectPhases.${newProjectPhase.projectPhaseId}`;
        const projectPhaseResult = dotPropImmutable.set(state, projectPhasePath, newProjectPhase);
        const templateRefPath = `data.${state.activeId}.template.templateContent.projectPhases`;
        const projectPhaseIds = dotPropImmutable.get(projectPhaseResult, templateRefPath, []);
        if (!insertAt) {
            return dotPropImmutable.set(projectPhaseResult, templateRefPath, [
                ...projectPhaseIds,
                newProjectPhase.projectPhaseId
            ]);
        }
        const insertAtIndex = projectPhaseIds.findIndex((i)=>i === insertAt.id);
        const modifiedProjectPhaseIds = insert(projectPhaseIds, insertAtIndex + insertAt.direction, newProjectPhase.projectPhaseId);
        const result = dotPropImmutable.set(projectPhaseResult, templateRefPath, modifiedProjectPhaseIds);
        return result;
    },
    updateProjectTemplateProjectPhase: (state, { payload: { projectPhase: payload, updatePrivacyOfChildren } })=>{
        const { tasks, private: isPrivate } = payload;
        let result = state;
        function setPrivate(_subTasks) {
            _subTasks === null || _subTasks === void 0 ? void 0 : _subTasks.forEach((sid)=>{
                const children = dotPropImmutable.get(result, `data.${state.activeId}.tasks.${sid}`);
                result = dotPropImmutable.set(result, `data.${state.activeId}.tasks.${sid}.private`, isPrivate);
                if (isPrivate) {
                    const responsibleOn = dotPropImmutable.get(result, `data.${state.activeId}.tasks.${sid}.responsibleOn`);
                    result = dotPropImmutable.set(result, `data.${state.activeId}.tasks.${sid}.responsibleOn`, responsibleOn === null || responsibleOn === void 0 ? void 0 : responsibleOn.filter((_value)=>_value !== MemberType.External));
                    const assigneeTeams = dotPropImmutable.get(result, `data.${state.activeId}.tasks.${sid}.assignee.teams`);
                    if (assigneeTeams) {
                        result = dotPropImmutable.set(result, `data.${state.activeId}.tasks.${sid}.assignee.teams`, assigneeTeams.filter((_team)=>_team.teamType !== MemberType.External));
                    }
                }
                if (children.subTasks.length > 0) {
                    setPrivate(children.subTasks);
                }
            });
        }
        if (updatePrivacyOfChildren === true) {
            setPrivate(tasks);
        }
        return dotPropImmutable.merge(result, `data.${state.activeId}.projectPhases.${payload.projectPhaseId}`, payload);
    },
    updateProjectTemplateProjectPhases: (state, { payload })=>{
        const updatedPhases = {};
        payload === null || payload === void 0 ? void 0 : payload.forEach(({ id, startDay, duration, assignees })=>{
            const phase = state.data[`${state.activeId}`].projectPhases[id];
            const updates = {};
            if (startDay) {
                updates.startDay = startDay;
            }
            if (duration) {
                updates.duration = duration;
            }
            if (assignees) {
                updates.assignees = assignees;
            }
            updatedPhases[id] = {
                ...phase,
                ...updates
            };
        });
        return dotPropImmutable.merge(state, `data.${state.activeId}.projectPhases`, updatedPhases);
    },
    makeDateShiftsForProjectPhases: (state, { payload })=>{
        const updatedPhases = {};
        payload === null || payload === void 0 ? void 0 : payload.forEach((phaseUpdates)=>{
            const { projectPhaseId: phaseId, startDate, dueDate } = phaseUpdates;
            const phase = state.data[`${state.activeId}`].projectPhases[phaseId];
            const currentStartDate = moment().add(phase.startDay, 'day').startOf('day').format(DEFAULT_DATE_FORMAT);
            const currentDueDate = moment().add(phase.startDay + phase.duration - 1, 'day').endOf('day').format(DEFAULT_DATE_FORMAT);
            updatedPhases[phaseId] = {
                ...phase,
                startDay: startDate ? Math.abs(moment().startOf('day').diff(moment(startDate), 'day', true)) : phase.startDay,
                duration: startDate || dueDate ? Math.round(moment(dueDate || currentDueDate).endOf('day').diff(moment(startDate || currentStartDate), 'day', true)) : phase.duration
            };
        });
        return dotPropImmutable.merge(state, `data.${state.activeId}.projectPhases`, updatedPhases);
    },
    deleteProjectTemplateProjectPhase: (state, { payload })=>{
        const path = `data.${state.activeId}.projectPhases.${payload.projectPhaseId}`;
        const { tasks } = dotPropImmutable.get(state, path);
        let result = deleteTasks(tasks, state);
        result = {
            ...result,
            ...dotPropImmutable.delete(result, path)
        };
        const projectPhases = dotPropImmutable.get(result, `data.${state.activeId}.template.templateContent.projectPhases`, []);
        result = dotPropImmutable.set(result, `data.${state.activeId}.template.templateContent.projectPhases`, projectPhases.filter((x)=>x !== payload.projectPhaseId));
        return result;
    },
    shiftStartDayOfProjectPhase: (state, { payload: { projectPhaseId, shiftBy } })=>{
        const projectPhasePath = `data.${state.activeId}.projectPhases.${projectPhaseId}`;
        const projectPhase = dotPropImmutable.get(state, projectPhasePath);
        const { tasks, startDay } = projectPhase;
        const result = shiftStartDay(tasks, shiftBy, state);
        return dotPropImmutable.set(result, `${projectPhasePath}.startDay`, startDay + shiftBy);
    }
};
